import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { Message } from 'element-ui';
import Cookies from 'js-cookie';

import Home from '../views/home/Index.vue'
import Document from '../views/ProductDocument/Index.vue'
import QuestionDetail from '../views/ProductDocument/QuestionDetail.vue'
import CommonQuestion from '../views/ProductDocument/components/commonQuestion.vue'
import QuestionType from '../views/ProductDocument/components/questionType.vue'
import NewUser from '../views/ProductDocument/components/newUser.vue'
import Dynamics from '../views/ProductDynamics/Index.vue'
import DynamicsDetail from '../views/ProductDynamics/DynamicsDetail.vue'
// import views
Vue.use(Router);

const inBrowser = typeof window !== 'undefined';


function preReqAuth(to, from, next) {
  next();
}

//定义滚动行为
const scrollBehavior = (to, from, savedPosition)=> {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {};
    if (to.hash) {
      position.selector = to.hash
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0;
      position.y = 0;
    }
    return position
  }
};

const router = new Router({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  routes: [
    {
      path: '/',
      redirect: {name: 'Home'},
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title:'首页'
      }
    },
    {
      path: '/document',
      name: 'Document',
      component: Document,
      redirect: {name: 'CommonQuestion'},
      meta: {
        title:'产品文档'
      },
      children:[
        {
          path: 'commonQuestion',
          name: 'CommonQuestion',
          component: CommonQuestion,
          meta: {
            title:'常见问题'
          }
        },
        {
          path: 'questionType',
          name: 'QuestionType',
          component: QuestionType,
          meta: {
            title:'问题类型'
          }
        },
        {
          path: 'newUser',
          name: 'NewUser',
          component: NewUser,
          meta: {
            title:'新手使用'
          }
        }
      ]
    },
    {
      path: '/document/questionDetail',
      name: 'QuestionDetail',
      component: QuestionDetail,
      meta: {
        title:'产品文档-问题详情',
        requiresAuth: true
      },
    },
    {
      path: '/dynamics',
      name: 'Dynamics',
      component: Dynamics,
      meta: {
        title:'产品动态'
      }
    },
    {
      path: '/dynamics/detail',
      name: 'DynamicsDetail',
      component: DynamicsDetail,
      meta: {
        title:'产品动态-详情',
        requiresAuth: true
      }
    }
  ]
});

function checkToken(to, from, next) {
  const COOKIE_NAME = store.state.User.clientCk;
  const token = Cookies.get(COOKIE_NAME);
  if (token) {
    next(); // 不需要登录，继续路由
  } else {
    if (!from.name) {
      next('/home');
    } else {
      store.commit('clearInfo');
    }
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // 解决刷新控制台报错问题
    setTimeout(() => checkToken(to, from, next), 0);
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js